import store from "@/store";
import CURRENCIES from "@/misc/currencies";

export default function (value) {
  if (typeof value !== "number") {
    return value;
  }
  const currentStore = store.getters["user/getCurrentStore"];
  const currencyObj = CURRENCIES.find((curr) => curr.region === currentStore.region);

  var formatter = new Intl.NumberFormat(currencyObj.locale, {
    style: "currency",
    currency: currencyObj.currency,
  });

  return formatter.format(value);
}
